import type {
  CreateDraftContractFromImportJobPayload,
  CreateDraftContractFromImportJobResponse,
} from './types';

import { ENDPOINT } from '~/constants/endpoints';

import { vestigasApi } from '~/services/kyClient';

import {
  zodCreateDraftContractFromImportJobPayloadSchema,
  zodCreateDraftContractFromImportJobResponseSchema,
} from './validations';

/**
 * Creates a draft contract from a finished import job. The server reads the
 * extracted header and every item from the job, attaches its PDF and marks
 * the job as done. The response leaves the items out; incomplete ones are
 * counted in `invalidItemsTotalCount`. A job that is not finished, was
 * already used or belongs to another account is refused with 409 or 404.
 *
 * @param payload - The import job and the buyer of the new contract.
 * @returns The created draft contract, without items.
 * @throws Error if the API request fails or validation fails.
 * @see https://app.dev.vestigas.com/redoc#tag/Contracts/operation/create_draft_from_import_job_contracts_drafts_from_import_job_post
 */
export const createDraftContractFromImportJob = async (
  payload: CreateDraftContractFromImportJobPayload,
) => {
  return await vestigasApi
    .post(ENDPOINT.CONTRACT.CREATE_DRAFT_FROM_IMPORT_JOB(), {
      json: payload,
      validate: {
        body: zodCreateDraftContractFromImportJobPayloadSchema,
        response: zodCreateDraftContractFromImportJobResponseSchema,
      },
    })
    .json<CreateDraftContractFromImportJobResponse>();
};
